import { render, staticRenderFns } from "./ProductWrapperView.vue?vue&type=template&id=3face9f6&"
import script from "./ProductWrapperView.vue?vue&type=script&lang=js&"
export * from "./ProductWrapperView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports